const SHOW = 'luft-promo/toast/SHOW';
const DISMISS = 'luft-promo/toast/DISMISS';
const CLEAR = 'luft-promo/toast/CLEAR';

export default {
  SHOW,
  DISMISS,
  CLEAR,
};
